export default __webpack_public_path__ + "static/media/ofek2.43d77232.jpg";